import React from 'react';
import { Box } from '@mui/material';
import { FaEnvelope } from "react-icons/fa";
import { useStyles } from '../styles/BuscaDesabilitadaStyles';

const BuscaDesabilitada: React.FC = () => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.iconContainer}>
        <FaEnvelope className={classes.icon} />
      </Box>

      <Box>
        <h3 
          className={classes.title}
        >
          Busca por e-mail desabilitada
        </h3>
        <p
          className={classes.subtitle}
        >
          A busca de notas fiscais por e-mail está desabilitada. Para usar essa opção,
          habilite acima e configure a forma de busca por e-mail desejada.
        </p>
      </Box>
    </Box>
  );
};

export default BuscaDesabilitada;